/**
 * Converts an underscore-delimited, typically upper-case token (e.g. an API
 * status enum) into human-readable title case.
 *
 * @example
 * ```typescript
 * snakeCaseToTitleCase("ELIGIBLE");    // "Eligible"
 * snakeCaseToTitleCase("NOT_COVERED"); // "Not Covered"
 * ```
 */
export const snakeCaseToTitleCase = (str: string) =>
  str
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
